import { lazy } from 'react';

const Game = lazy(
	() =>
		import(
			/* webpackChunkName: "game" */
			'./game'
		)
);

export default Game;
